import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom";
import { useRedemptionData } from "../../Context/redemption";
import { Steps as RegularSteps, SuccessRedemption } from "../RedeemCodes";
import LoadingSpinner from "../Common/LoadingSpinner";
import Success from "./Success"
import Steps from "./Steps"

function UserRedemptionPage() {
    const { UserId, RedeemCode } = useParams();
    const {
        getRedemptionPageInfo,
        redemptionPageData,
        redemptionPageInfo,
        redeemCodeInfo,
    } = useRedemptionData();
    const [successData, setSuccessData] = useState();
    const [regularSuccess, setRegularSuccess] = useState(false);
    // Track whether the initial page-info fetch resolved, so we don't decide
    // "no custom page" while still loading.
    const [pageInfoChecked, setPageInfoChecked] = useState(false);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            if (UserId && redemptionPageData?.UserId !== parseInt(UserId)) {
                await getRedemptionPageInfo(parseInt(UserId));
            }
            if (!cancelled) setPageInfoChecked(true);
        })();
        return () => { cancelled = true };
    }, [UserId]);

    // When the URL's UserId has no custom redemption page set up,
    // the user should see the regular RedeemCodes
    // experience (bg image, gift-card visual, etc.) instead of the custom one.
    const enteredCode = redeemCodeInfo?.RedemptionCodeAsEntered;
    const hasUrlCustom = !!redemptionPageInfo;
    const codeHasCustom = !!redeemCodeInfo?.UserRedemptionPageInfo;
    const useRegularFlow = pageInfoChecked && (!hasUrlCustom && !codeHasCustom);

    if (!pageInfoChecked) {
        return <LoadingSpinner />;
    }

    if (useRegularFlow) {
        return regularSuccess
            ? <SuccessRedemption isAddToDonation={false} />
            : <RegularSteps setSuccess={setRegularSuccess} />;
    }

    return successData
        ? <Success successData={successData} userId={parseInt(UserId)} />
        : <Steps onSuccess={(data) => setSuccessData(data)} userId={parseInt(UserId)} />
}
export default UserRedemptionPage;